/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ai_Voice_Agents_Qualify_Desc7Inputs */

const en_svc_ai_voice_agents_qualify_desc7 = /** @type {(inputs: Svc_Ai_Voice_Agents_Qualify_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Budget, timeline and intent captured in natural conversation, scored and pushed to your pipeline.`)
};

const ar_svc_ai_voice_agents_qualify_desc7 = /** @type {(inputs: Svc_Ai_Voice_Agents_Qualify_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`يتم التقاط الميزانية والجدول الزمني والنية في محادثة طبيعية، وتقييمها ودفعها إلى مسار مبيعاتك.`)
};

const bn_svc_ai_voice_agents_qualify_desc7 = /** @type {(inputs: Svc_Ai_Voice_Agents_Qualify_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`বাজেট, সময়সীমা আর উদ্দেশ্য স্বাভাবিক কথোপকথনে ধরা হয়, স্কোর করে আপনার পাইপলাইনে পাঠানো হয়।`)
};

const de_svc_ai_voice_agents_qualify_desc7 = /** @type {(inputs: Svc_Ai_Voice_Agents_Qualify_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Budget, Zeitrahmen und Kaufabsicht werden im natürlichen Gespräch erfasst, bewertet und in Ihre Pipeline übertragen.`)
};

const es_svc_ai_voice_agents_qualify_desc7 = /** @type {(inputs: Svc_Ai_Voice_Agents_Qualify_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Presupuesto, plazos e intención captados en conversación natural, puntuados y enviados a su pipeline.`)
};

const fr_svc_ai_voice_agents_qualify_desc7 = /** @type {(inputs: Svc_Ai_Voice_Agents_Qualify_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Budget, calendrier et intention captés en conversation naturelle, notés et envoyés vers votre pipeline.`)
};

const pt_svc_ai_voice_agents_qualify_desc7 = /** @type {(inputs: Svc_Ai_Voice_Agents_Qualify_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Orçamento, prazo e intenção captados em conversa natural, pontuados e enviados ao seu pipeline.`)
};

const zh_svc_ai_voice_agents_qualify_desc7 = /** @type {(inputs: Svc_Ai_Voice_Agents_Qualify_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在自然对话中获取预算、时间和意向，评分后推送到你的销售管道。`)
};

const tr_svc_ai_voice_agents_qualify_desc7 = /** @type {(inputs: Svc_Ai_Voice_Agents_Qualify_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bütçe, zaman çizelgesi ve niyet doğal sohbette yakalanır, puanlanır ve hattınıza aktarılır.`)
};

const ru_svc_ai_voice_agents_qualify_desc7 = /** @type {(inputs: Svc_Ai_Voice_Agents_Qualify_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Бюджет, сроки и намерение считываются в естественном разговоре, оцениваются и передаются в вашу воронку.`)
};

const pl_svc_ai_voice_agents_qualify_desc7 = /** @type {(inputs: Svc_Ai_Voice_Agents_Qualify_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Budżet, horyzont czasowy i intencja wychwycone w naturalnej rozmowie, ocenione i przekazane do lejka sprzedażowego.`)
};

/**
* | output |
* | --- |
* | "Budget, timeline and intent captured in natural conversation, scored and pushed to your pipeline." |
*
* @param {Svc_Ai_Voice_Agents_Qualify_Desc7Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ai_voice_agents_qualify_desc7 = /** @type {((inputs?: Svc_Ai_Voice_Agents_Qualify_Desc7Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ai_Voice_Agents_Qualify_Desc7Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ai_voice_agents_qualify_desc7(inputs)
	if (locale === "bn") return bn_svc_ai_voice_agents_qualify_desc7(inputs)
	if (locale === "de") return de_svc_ai_voice_agents_qualify_desc7(inputs)
	if (locale === "es") return es_svc_ai_voice_agents_qualify_desc7(inputs)
	if (locale === "fr") return fr_svc_ai_voice_agents_qualify_desc7(inputs)
	if (locale === "pt") return pt_svc_ai_voice_agents_qualify_desc7(inputs)
	if (locale === "zh") return zh_svc_ai_voice_agents_qualify_desc7(inputs)
	if (locale === "tr") return tr_svc_ai_voice_agents_qualify_desc7(inputs)
	if (locale === "ru") return ru_svc_ai_voice_agents_qualify_desc7(inputs)
	if (locale === "pl") return pl_svc_ai_voice_agents_qualify_desc7(inputs)
	return en_svc_ai_voice_agents_qualify_desc7(inputs)
});
export { svc_ai_voice_agents_qualify_desc7 as "svc_ai-voice-agents_QUALIFY_desc" }